import paymentsTypes from '../../constants/paymentsTypes'
export * from './get'
export * from './getindex'
export * from './getxlsx'
export * from './receipt'
export * from './send_receipt'

const set_payment_errors = (messages) => {
  return {
    type: paymentsTypes.set_errors,
    payload: messages
  }
}

export {
  set_payment_errors,
}



// WEBPACK FOOTER //
// ./src/js/actions/payments/index.js